import { useEffect, useId, useState } from "react";
import { useTranslation } from "react-i18next";
import { api, getToken } from "../utils/helpers";

// The API returns names and keys only. Passwords never enter this control.
export default function PolicyCredentialSource({ instanceId, source, value, onChange, creating = false, invalid = false, SelectComponent = "select", ButtonComponent = "button" }) {
  const { t } = useTranslation(["space", "gemeinsam"]);
  const id = useId();
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (source || !instanceId) return;
    const controller = new AbortController();
    const token = getToken();
    setResult(null); setError(null);
    api(`/api/instances/${instanceId}/policy-source`, { signal: controller.signal }).then(data => {
      if (controller.signal.aborted || getToken() !== token) return;
      if (!data?.instanceId || !Array.isArray(data.credentials)) throw new Error(t("policySource.loadError"));
      setResult(data);
    }).catch(e => { if (!controller.signal.aborted && getToken() === token) setError(e.message); });
    return () => controller.abort();
  }, [instanceId, source, attempt, t]);
  const data = source || result;
  const options = (data?.credentials || []).filter(c => c.available);
  const selected = value ? JSON.stringify({ instanceId: value.instanceId, key: value.key }) : "";
  const present = value && data?.instanceId === value.instanceId && options.some(c => c.key === value.key);
  return <div className="iio-field ci-policy-source" style={{ minWidth: 0, marginTop: 12 }}>
    <label id={`${id}-label`} className="iio-field-label" htmlFor={id}>{t("policySource.label")}</label>
    <SelectComponent aria-label={t("policySource.label")} id={id} className="iio-input" value={selected} aria-describedby={`${id}-hint`}
      style={{ width: "100%", minWidth: 0, minHeight: 44 }}
      onChange={e => onChange(e.target.value ? JSON.parse(e.target.value) : null)}>
      <option value="">{t(creating ? "policySource.none" : "policySource.local")}</option>
      {value && !present && <option value={selected}>{t("policySource.current", { key: value.key || t("policySource.default") })}</option>}
      {options.map(c => <option key={c.key} value={JSON.stringify({ instanceId: data.instanceId, key: c.key })}>
        {t("policySource.option", { key: c.key || t("policySource.default"), username: c.username })}
      </option>)}
    </SelectComponent>
    <div id={`${id}-hint`} className="iio-field-hint" style={{ overflowWrap: "anywhere" }}>
      {t(value ? "policySource.linkedHint" : "policySource.hint")}
      {value && <div>{t("policyTransport.inherited")}</div>}
      {data && <div>{t("policySource.template", { name: data.name })}</div>}
      {data && options.length === 0 && <div>{t("policySource.empty")}</div>}
      {!data && !error && <div role="status">{t("policySource.loading")}</div>}
    </div>
    {invalid && <p role="alert" className="iio-field-hint">{t("policySource.invalid")}</p>}
    {error && <div role="alert" className="iio-field-hint">
      <p>{t("policySource.loadError")} {error}</p>
      <ButtonComponent type="button" className="iio-btn iio-btn--secondary" onClick={() => setAttempt(n => n + 1)}>{t("policySource.retry")}</ButtonComponent>
    </div>}
  </div>;
}
